import {useMutation} from '@tanstack/react-query';
import {QuestionsAndAnswersScheduleScriptProps} from '../../services/questionsAndAnswersScheduleScript/types';
import {questionsAndAnswersScheduleScript} from '../../services/questionsAndAnswersScheduleScript';

function useQuestionsAndAnswersScheduleScriptMutation() {
  return useMutation({
    mutationFn: (params: QuestionsAndAnswersScheduleScriptProps) =>
      questionsAndAnswersScheduleScript(params),
    retry: 3,
  });
}

export {
  useQuestionsAndAnswersScheduleScriptMutation,
};
